import PropTypes from 'prop-types';
var propTypes = {
  component: PropTypes.elementType,
  highlightedRef: PropTypes.any,
  id: PropTypes.string,
  menuItemCustomProps: PropTypes.shape({}),
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  onScroll: PropTypes.func,
  role: PropTypes.string,
  selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default propTypes;